import React from 'react'
import { NewWindowIcon } from '../../../ui/gov-messages'
import { toParentApproval } from '../../../navigate'

const ParentalAgreementLink = ({ record, children }) => (
  <div className="recordDisplayList--heading--title--wrapper">
    {children}
    <a href={toParentApproval(record)} rel="noopener noreferrer" target="_blank">
      View Parent Approval
      <NewWindowIcon />
    </a>
  </div>
)

export default ParentalAgreementLink


// WEBPACK FOOTER //
// ./src/care-enrolments/details/views/parental-agreement-link.jsx